import "./style.css";
import chevronLeft from "../../assets/imgs/chevron-left.svg";
import { useNavigate } from "react-router-dom";

export const Breadcrumb = ({ text = "", navigateTo = -1 }) => {
  const navigate = useNavigate();

  return (
    <div
      className={`breadcrumb-component text-md bold`}
      onClick={() => {
        navigate(navigateTo);
      }}>
      <img src={chevronLeft} />
      {text}
    </div>
  );
};
